import { FormsFieldPreset, FormPlugin } from '@wix/forms-common'
import { GeneralText } from '../../general-fields/definitions/general-text'
import { CRM_TYPES } from '../../../../../../constants/crm-types-tags'
import { iconNames } from '../../icons/types'
import { CATEGORIES } from '../../../../../../panels/manage-fields-panel/constants/manage-fields-constants'

export class FirstName extends GeneralText {
  public get customFields() {
    return this.base.customFields
  }

  public get fieldType(): FieldPreset {
    return FormsFieldPreset.FIRST_NAME
  }

  protected get icon() {
    return iconNames.name
  }

  public get crmType() {
    return CRM_TYPES.FIRST_NAME
  }

  protected get data() {
    return {
      textType: 'text',
      placeholder: this.translate(`fieldTypes.${this.fieldType}`),
    }
  }

  protected get renderConfig() {
    return {
      [FormPlugin.FORM_BUILDER]: {
        addFieldPanelData: {
          category: CATEGORIES.contact,
        },
      },
    }
  }
}
